module.exports = __webpack_public_path__ + "img/cart.4b025189.png";